/**
 * Storybook 프리뷰 환경 여부.
 *
 * Storybook 미리보기는 `__STORYBOOK_PREVIEW__` / `__STORYBOOK_ADDONS_CHANNEL__` 전역을 노출하고
 * 프리뷰 iframe 을 `/iframe.html` 로 서빙한다. 세 신호 중 하나라도 맞으면 Storybook 으로 판정한다.
 *
 * 클라이언트 전용(`.client.ts`) 플러그인에서 호출되지만 SSR/비브라우저 안전을 위해 `window` 가드를 둔다.
 * (이전에는 onboarding/survey/channelTalk 플러그인이 각자 미묘하게 다른 복사본을 두고 있었음 — 단일화.)
 */
export const isStorybookEnvironment = (): boolean => {
    if (typeof window === 'undefined') return false;
    const w = window as unknown as {
        __STORYBOOK_PREVIEW__?: unknown;
        __STORYBOOK_ADDONS_CHANNEL__?: unknown;
    };
    return (
        w.__STORYBOOK_PREVIEW__ !== undefined ||
        w.__STORYBOOK_ADDONS_CHANNEL__ !== undefined ||
        window.location.pathname.includes('iframe.html')
    );
};
